module.exports = __webpack_public_path__ + "img/robot.182c1ce9.png";